import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "piarTabs",
  role: "tablist"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = ["aria-selected"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-draft" }, null, -1)
const _hoisted_9 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_10 = ["aria-selected", "disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-settings" }, null, -1)
const _hoisted_12 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "piarTabsContent"
}
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = {
  key: 0,
  class: "text-center text-success my-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, " Cargando información...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PiarBasicDataTab = _resolveComponent("PiarBasicDataTab")!
  const _component_PiarAdjustmentsTab = _resolveComponent("PiarAdjustmentsTab")!
  const _component_b_spinner = _resolveComponent("b-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100", { active: _ctx.activeTab === 0 }]),
                id: "tab-basic-data",
                type: "button",
                role: "tab",
                "aria-controls": "tab-basic-data-pane",
                "aria-selected": _ctx.activeTab === 0 ? 'true' : 'false',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab(0)))
              }, [
                _hoisted_8,
                _createTextVNode(" DATOS BÁSICOS ")
              ], 10, _hoisted_7)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100", { active: _ctx.activeTab === 1, disabled: _ctx.isNew }]),
                id: "tab-ajustes",
                type: "button",
                role: "tab",
                "aria-controls": "tab-ajustes-pane",
                "aria-selected": _ctx.activeTab === 1 ? 'true' : 'false',
                disabled: _ctx.isNew,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.isNew && _ctx.setTab(1)))
              }, [
                _hoisted_11,
                _createTextVNode(" AJUSTES ")
              ], 10, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === 0 }]),
              id: "tab-basic-data-pane",
              role: "tabpanel",
              tabindex: "0"
            }, [
              (_ctx.loaded)
                ? (_openBlock(), _createBlock(_component_PiarBasicDataTab, {
                    key: 0,
                    piar: _ctx.piar,
                    "is-new": _ctx.isNew
                  }, null, 8, ["piar", "is-new"]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === 1 }]),
              id: "tab-ajustes-pane",
              role: "tabpanel",
              tabindex: "0"
            }, [
              (_ctx.loaded && !_ctx.isNew)
                ? (_openBlock(), _createBlock(_component_PiarAdjustmentsTab, {
                    key: 0,
                    "piar-id": _ctx.piarId
                  }, null, 8, ["piar-id"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, " Guarda primero el PIAR para gestionar los ajustes. "))
            ], 2)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_b_spinner, { class: "align-middle" }),
                _hoisted_15
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}